module.exports = __webpack_public_path__ + "static/media/radio-button.f3c23a64.svg";